import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const ProtectedRoute = () => {
  if (!isAuthenticated()) {
    // Not authenticated → send to login
    return <Navigate to="/" replace />;
  }
  // Authenticated → show nested routes (e.g. /dashboard/*)
  return <Outlet />;
};

export default ProtectedRoute;